/**
 * Carrier price resolution, shared by the lane list cell and the Carrier Price
 * sort accessor.
 */

/** Labels whose carrier price is locked to a negotiated minimum. */
export const AWARDED_LABELS = ['Awarded', 'Awarded Lane']

/**
 * Which carrier price field is live for a lane.
 *
 * The editor points its single Carrier Price input at `lockCarrierPrice` while
 * the label is Awarded and at `carrierPrice` otherwise (LaneEditorForm.view),
 * and never clears the other one — so a lane that was once Awarded keeps a
 * stale `lockCarrierPrice`. Both the list cell and the sort accessor have to
 * pick the field the label says is live, or the column sorts by a value it
 * does not display.
 *
 * @param {Object} [administration] - lane.administration
 * @returns {{ value: number|undefined, locked: boolean }}
 */
export const resolveCarrierPrice = (administration) => {
  const { label, lockCarrierPrice, carrierPrice } = administration || {}
  const locked = AWARDED_LABELS.includes(label) && !!lockCarrierPrice

  return { value: locked ? lockCarrierPrice : carrierPrice, locked }
}
